export const getFormattedDate = (time: number) => {
  const deadline = new Date(time)
  const year = deadline.toLocaleString(undefined, {
    year: "numeric",
  })
  const month = deadline.toLocaleString(undefined, {
    month: "long",
  })
  const day = deadline.toLocaleString(undefined, {
    day: "numeric",
  })
  return `${day} ${month}, ${year}`
}

export function dateToSortableString(date: Date): string {
	return JSON.stringify(date).slice(1, -1)
}

export function formatDate(dateStr: string, difference?: boolean): string {
  const months: string[] = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ]
  const date = new Date(dateStr)

  const day: number = date.getDate()
  const month: string = months[date.getMonth()]
  const year: number = date.getFullYear()

  const currentDate: Date = new Date()
  const timeDiff: number = Math.abs(date.getTime() - currentDate.getTime())
  const diffDays: number = Math.ceil(timeDiff / (1000 * 3600 * 24))

  let dateString = `${day} ${month} ${year}`

  if (date.getTime() > currentDate.getTime() && difference) {
    dateString += ` (${diffDays} days)`
  }

  return dateString
}

export type DateCategories =
	| "Today"
	| "This week"
	| "This month"
	| "This year"

export function getDateCategory(
	dateString: string,
): DateCategories {
	const currentDate = new Date()
	const inputDate = new Date(dateString)

	const currentYear = currentDate.getFullYear()
	const currentMonth = currentDate.getMonth()
	const currentWeek = getWeekNumber(currentDate)
	const currentDay = currentDate.getDate()

	const inputYear = inputDate.getFullYear()
	const inputMonth = inputDate.getMonth()
	const inputWeek = getWeekNumber(inputDate)
	const inputDay = inputDate.getDate()

	if (currentYear === inputYear) {
		if (currentMonth === inputMonth) {
			if (currentDay === inputDay) {
				return "Today"
			} else if (currentWeek === inputWeek) {
				return "This week"
			} else {
				return "This month"
			}
		} else {
			return "This year"
		}
	} else {
		return "This year"
	}
}

export function getWeekNumber(date: Date): number {
	const d = new Date(
		Date.UTC(
			date.getFullYear(),
			date.getMonth(),
			date.getDate(),
		),
	)
	d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7))
	const yearStart = new Date(
		Date.UTC(d.getUTCFullYear(), 0, 1),
	)
	const weekNo = Math.ceil(
		((d.valueOf() - yearStart.valueOf()) / 86400000 + 1) /
			7,
	)
	return weekNo
}

